import React from 'react';

import InputSelectField from './InputSelectField';

import './DataTablePagination.scss';

class DataTablePagination extends React.Component {
  state = {
    currentPage: '1'
  };

  static getDerivedStateFromProps(props) {
    return {
      currentPage: String((props.offset / props.limit) + 1)
    }
  }

  handleCurrentPageChange = value => {
    this.setState({ currentPage: value });

    const parsedValue = parseInt(value);
    this.props.onChange(parsedValue);
  }

  handlePrevPageClick = () => {
    const currentPage = parseInt(this.state.currentPage);
    const newPage = (currentPage - 1);
    this.handleCurrentPageChange(String(newPage));
  }

  handleNextPageClick = () => {
    const currentPage = parseInt(this.state.currentPage);
    const newPage = (currentPage + 1);
    this.handleCurrentPageChange(String(newPage));
  }

  render() {
    const { dataTableId, overallRowCount, limit } = this.props;

    const currentPage = parseInt(this.state.currentPage);
    const totalPages = Math.ceil(overallRowCount / limit);

    let options = [];
    for (let i = 1; i <= totalPages; i++) {
      options.push({ value: `${i}`, label: `${i}` });
    }

    const displayPrev = currentPage > 1;
    const displayNext = currentPage < totalPages;

    return (
      <div className="parkchirp--data-table-option parkchirp--data-table-option--pagination">
        {displayPrev &&
          <span
            className="parkchirp--data-table-pagination-link parkchirp--data-table-pagination-link--prev"
            onClick={this.handlePrevPageClick}
          >&lt; Prev</span>
        }
        <span>Page</span>
        <InputSelectField
          inputId={`parkchirp--data-table--${dataTableId}--pagination-page`}
          options={options}
          value={this.state.currentPage}
          onChange={this.handleCurrentPageChange}
          editMode={true}
        />
        <span>of {totalPages}</span>
        {displayNext &&
          <span
            className="parkchirp--data-table-pagination-link parkchirp--data-table-pagination-link--next"
            onClick={this.handleNextPageClick}
          >Next &gt;</span>
        }
      </div>
    );
  }
}

export default DataTablePagination;
